import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Button,
} from "@mui/material";
import {
    makeGETRequestOnUserService,
    makePOSTRequestOnUserService,
    makePUTRequestOnUserService,
} from "../../Api/api";

export const NomineeDetails = ({ activeTab, currentUser, user_type, setValue, getErrorMessage }: any) => {
    const [form, setForm] = useState({
        name: "",
        date_of_birth: "",
        relationship: "",
        mobileNumber: ""
    });
    const toastr = require("toastr");
    const [nomineeId, setNomineeId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [originalMobile, setOriginalMobile] = useState("");

    const handleChange = (e: any) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const formatDate = (date: any) => {
        if (!date) return "";
        const [y, m, d] = date.split("-");
        return `${d}/${m}/${y}`;
    };

    const isValidMobile = (mobile: any) => {
        return /^[0-9]{10}$/.test(mobile);
    };

    const fetchNominee = async () => {
        try {
            setLoading(true);

            const res = await makeGETRequestOnUserService(
                `/partneruser/get_nominee/${user_type}/${currentUser.uuid}/`
            );
            const apiData = res?.data?.data || [];
            if (apiData.length > 0) {
                const data = apiData[0];
                setForm({
                    name: data.name || "",
                    date_of_birth: data.date_of_birth || "",
                    relationship: data.relationship || "",
                    mobileNumber: data.mobileNumber || ""
                });
                setNomineeId(data.uuid);
                setOriginalMobile(data.mobileNumber || "");
            } else {
                setNomineeId(null);
                setForm({
                    name: "",
                    date_of_birth: "",
                    relationship: "",
                    mobileNumber: ""
                });
            }
        } catch (err) {
            toastr.error(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    const createNominee = async () => {
        if (!isValidMobile(form.mobileNumber)) {
            toastr.error("Enter valid 10 digit mobile number");
            return;
        }

        try {
            setLoading(true);
            const resp = await makePOSTRequestOnUserService(
                `/partneruser/create_nominee/`,
                {
                    userId: currentUser.uuid,
                    user_type: user_type,
                    name: form.name,
                    relationship: form.relationship,
                    mobileNumber: form.mobileNumber,
                    date_of_birth: formatDate(form.date_of_birth)
                }
            );
            if (resp.status === 200 || resp.status === 201) {
                toastr.success("Nominee Created Successfully");
                fetchNominee();
                setValue((prev: number) => prev + 1);
            }
        } catch (err: any) {
            toastr.error(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    const updateNominee = async () => {
        if (!isValidMobile(form.mobileNumber)) {
            toastr.error("Enter valid 10 digit mobile number");
            return;
        }
        try {
            setLoading(true);
            const payload: any = {
                name: form.name,
                relationship: form.relationship,
                date_of_birth: formatDate(form.date_of_birth)
            };
            if (form.mobileNumber !== originalMobile) {
                payload.mobileNumber = form.mobileNumber;
            }
            const resp = await makePUTRequestOnUserService(
                `/partneruser/update_nominee/${user_type}/${currentUser.uuid}/${nomineeId}/`,
                payload
            );
            if (resp.status === 200) {
                toastr.success("Nominee Updated Successfully");
                setOriginalMobile(form.mobileNumber);
            }
        } catch (err: any) {
            toastr.error(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (
            activeTab === "kycNominee" ||
            activeTab === "nomineeDetails"
        ) {
            fetchNominee();
        }
    }, [activeTab, currentUser?.uuid, user_type]);

    const mobileError = form.mobileNumber.length > 0 && !isValidMobile(form.mobileNumber);

    return (
        <Box sx={{ p: 3 }}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Nominee Name"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Nominee Date of Birth"
                        type="date"
                        name="date_of_birth"
                        value={form.date_of_birth}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Nominee Relationship"
                        name="relationship"
                        value={form.relationship}
                        onChange={handleChange}
                    >
                    </TextField>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Nominee Mobile Number"
                        name="mobileNumber"
                        value={form.mobileNumber}
                        onChange={handleChange}
                        error={mobileError}
                        helperText={
                            mobileError
                                ? "Enter valid 10 digit mobile number"
                                : ""
                        }
                    />
                </Grid>

                <Grid item xs={12} textAlign="center">
                    {nomineeId ? (
                        <Button
                            variant="contained"
                            onClick={updateNominee}
                            sx={{
                                backgroundColor: "#262349",
                                "&:hover": { backgroundColor: "#1d1a3a" }
                            }}
                        >UPDATE NOMINEE</Button>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={createNominee}
                            sx={{
                                backgroundColor: "#262349",
                                "&:hover": { backgroundColor: "#1d1a3a" }
                            }}
                        >CREATE NOMINEE</Button>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};